// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU8_thecomp__H2OTV"};